module.exports = __webpack_public_path__ + "public/img/whh_qr.717857db.jpg";